<template>
  <page-wrapper title="ใบเสร็จไม่ส่ง SAP (manual close)">
    <div class="Sap-fi-not-send-receipt">
      <div class="receipt-select mt-4 mb-4">
        <div class="">
          <div class="label">เลขที่เอกสารที่จะไม่ส่งไป sap(FI)</div>
          <el-input
            v-model="documentNumbersForManualCloseSap"
            class="text-document"
            type="textarea"
            rows="3"
            placeholder="ใส่ , คั่นเลขเอกสาร (Ex: 2019010001,2019010002)"
          ></el-input>
        </div>
        <div class="btn-select mt-1">
          <div class="right">
            <sc-button
              variant="primary"
              @click="handleClickNotSendSapFiByDocumentNumbers"
              >ยืนยันปิดไม่ส่ง sap</sc-button
            >
          </div>
        </div>
      </div>
      <div class="report">
        <log-admin-report-by-feature
          target-feature="RECEIPT"
          activity="BLOCK_RECEIPT_TO_GENERATE_SAP"
        ></log-admin-report-by-feature>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import { Input } from "element-ui"
import ScButton from "@/lib/components/ScButton"
import { baanRueJaiClient } from "@/dependencies"
import LogAdminReportByFeature from "@/lib/components/LogAdminReportByFeature"
import PageWrapper from "@/lib/components/PageWrapper"
import { existValueAndEmptyString } from "../../../lib/util"

export default {
  components: {
    LogAdminReportByFeature,
    PageWrapper,
    "el-input": Input,
    ScButton,
  },
  data() {
    return {
      documentNumbersForManualCloseSap: null,
    }
  },
  methods: {
    async handleClickNotSendSapFiByDocumentNumbers() {
      if (!existValueAndEmptyString(this.documentNumbersForManualCloseSap)) {
        this.$message.error('กรุณากรอกข้อมูล "เลขที่เอกสารที่จะไม่ส่งไป sap"')
        return
      }

      if (
        // eslint-disable-next-line no-alert
        !window.confirm(
          `${this.documentNumbersForManualCloseSap}\n\nรายการใบเสร็จนี้ จะไม่ถูกส่งไป Sap(FI)`,
        )
      ) {
        return
      }

      await this.updateNotSendSapFiByDocumentNumbers()
    },
    async updateNotSendSapFiByDocumentNumbers() {
      try {
        await baanRueJaiClient.admin.sap.putNotSendSapFiByDocumentNumbers({
          document_numbers: this.documentNumbersForManualCloseSap
            .replace(/\s/g, "")
            .split(","),
        })
      } catch (error) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          this.$message.error(error.response.data.message)
        } else {
          this.$message.error("ไม่สามารถบันทึกได้")
        }

        // eslint-disable-next-line no-console
        console.log(error.response)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.receipt-select {
  padding-left: 15px;
  padding-right: 20px;
}

.right {
  text-align: right;
}

.btn-select {
  width: auto;
}
</style>
